"use strict";
import {templates} from "Subschema";
import SingleLineLess from './SingleLine.less';
export default {
    'template': templates.FieldSetTemplate,
    'className':SingleLineLess.container

};


/** WEBPACK FOOTER **
 ** ./src/templates/SingleLine.js
 **/